<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item>
              <!-- 关键字搜索 -->
              <a-input v-model="queryParam.keyWord" placeholder="请输入关键字">
                <!-- 选择搜索类型 -->
                <a-select slot="addonBefore" v-model="queryParam.keyWordType" placeholder="请选择" style="width:100px">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in keyWordTypeList">{{ item.name }}</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 筛选状态查找 -->
          <a-col :md="6" :sm="24">
            <a-form-item title="状态">
              <div style="display: flex;">
                <a-input placeholder="状态" disabled style="width: 80px;text-align: center;"></a-input>
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option :value="item.id" :key="item.id" v-for="item in dict.statusDict">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="openAddDrawer" style="margin-right:15px;">新增用户</a-button>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="status" slot-scope="text">{{ text | valInDict(dict.statusDict) }}</span>
      <span slot="role" slot-scope="text">{{ text | valInDict(dict.roleDict) }}</span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openViewModal(record.admin_id, edit=false)">查看</a>
        </template>
        <a-divider type="vertical" />
        <template>
          <a @click="openViewModal(record.admin_id, edit=true)">编辑</a>
        </template>
        <a-divider type="vertical" />
        <template>
          <a-dropdown>
            <a-popconfirm title="确定删除角色？" @confirm="deleteAdmin(record.admin_id)">
              <a>删除</a>
            </a-popconfirm>
          </a-dropdown>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <viewDrawer
      v-if="viewVisible"
      :visible="viewVisible"
      :id="admin_id"
      :edit="edit"
      @hide="cancelViewDrawer"
      @finish="finishViewAndEdit"/>
    <!-- 添加抽屉 -->
    <addDrawer v-if="addDrawerVisible" :visible="addDrawerVisible" @hide="handelAddDrawer" @finish="finish"></addDrawer>
    <!-- 权限设置抽屉 -->
    <rolePermission
      v-if="rolePermissionVisible"
      :visible="rolePermissionVisible"
      :roleId="role_id"
      :defalutPermissionArr="defalutPermissionArr"
      @hide="handelRolePermission"
      @finish="handelRolePermission">
    </rolePermission>
  </a-card>
</template>
<script>
import { pre, getAdminList, postDeleteAdmin } from '@/api/admin'
import { TcgTable } from '@/components'
import viewDrawer from './Admin/viewDrawer'
import addDrawer from './Admin/addDrawer'
import rolePermission from './Role/rolePermission'
import _ from 'lodash'
const keyWordTypeList = [
  {
    id: 'account',
    name: '账号'
  },
  {
    id: 'nickname',
    name: '联系人姓名'
  },
  {
    id: 'phone',
    name: '联系人电话'
  },
  {
    id: 'role_name',
    name: '角色名称'
  }
]
export default {
  components: {
    TcgTable,
    viewDrawer,
    addDrawer,
    rolePermission
  },
  data () {
    return {
      // 添加抽屉状态开关
      addDrawerVisible: false,
      // 编辑抽屉状态开关
      editDrawerVisible: false,
      // 设置权限抽屉开关
      rolePermissionVisible: false,
      // 关键字搜索类型列表
      keyWordTypeList,
      // 字典
      dict: {
        statusDict: [],
        roleDict: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: '',
        keyWordType: 'account',
        keyWord: ''
      },
      // 表头
      columns: [
        {
          title: '登录账号',
          dataIndex: 'account',
          width: '100px'
        },
        {
          title: '联系人名称',
          dataIndex: 'nickname',
          width: '100px'
        },
        {
          title: '联系电话',
          dataIndex: 'phone',
          width: '100px'
        },
        {
          title: '所属角色',
          dataIndex: 'role_id',
          width: '100px',
          scopedSlots: { customRender: 'role' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '100px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '200px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '200px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getAdminList(Object.assign(parameter, this.queryParam)).then(res => {
          return res
        })
      },
      viewVisible: false,
      admin_id: '',
      defalutPermissionArr: [],
      edit: false
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      pre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict.roleDict = _.get(res, 'values.roleDict', [])
          this.dict.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        keyWordType: 'account',
        keyWord: ''
      }
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
      this.edit = false
    },
    // 打开查看抽屉
    openViewModal (id, edit) {
      this.admin_id = id
      this.edit = edit
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 完成创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加用户抽屉
    openAddDrawer () {
      this.addDrawerVisible = true
    },
    // 关闭添加用户抽屉
    handelAddDrawer () {
      this.addDrawerVisible = false
    },
    // 打开权限设置抽屉
    openRolePermission (record) {
      this.role_id = record.role_id
      this.defalutPermissionArr = record.role_auth.split(',')
      for (const i in this.defalutPermissionArr) {
        this.defalutPermissionArr[i] = parseInt(this.defalutPermissionArr[i])
      }
      this.rolePermissionVisible = true
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
      this.$refs.table.refresh(true)
    },
    // 打开编辑抽屉
    openEditDrawer (id) {
      this.userId = id
      this.editDrawerVisible = true
    },
    // 关闭编辑抽屉
    handelEditDrawer () {
      this.editDrawerVisible = false
    },
    // 删除事件
    deleteAdmin (id) {
      postDeleteAdmin(id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        }
      })
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
